<script>
  export let errors = {}
  export let attribute;
</script>

{#if errors && errors[attribute]}
  <div class="form-text text-danger">{errors[attribute].join(", ")}</div>
{/if}
